import { createBrowserRouter } from 'react-router-dom';
import { useEffect, lazy } from 'react';
import { useLocation } from 'react-router-dom';
import { getQuery, getParams } from './historyPush';
import { matchPath } from './matchPath';
import config, { routePaths } from './config';

const router = createBrowserRouter(config);

// // 全局监听路由变化（替代history.listen）
// router.subscribe((state) => {
//     // 可在此实现埋点、权限校验、页面标题修改等逻辑
//     // 发送请求
// });

export * from './config';
export * from './addRouterApi';
export * from './matchPath';
export * from './historyPush';
export default router;

export const getRedirectUrl = () => {
    const { pathname } = window.location;
    for (const key in routePaths) {
        if (Object.prototype.hasOwnProperty.call(routePaths, key)) {
            const path = routePaths[key];
            // const menu = matchPath(pathname, {
            //     path: path,
            //     exact: true,
            // });
            if (matchPath(pathname, { path, exact: true })) {
                const query = getQuery();
                const params = getParams({ path, pathname });
                return {
                    path,
                    query,
                    params,
                };
            }
        }
    }
};
